module.exports = __webpack_public_path__ + "img/suspensionPoint2.be7889fb.png";